import React, { createContext, useState, useContext } from "react";

const NpsState = createContext(); 

export const useNpsState = () => {
  return useContext(NpsState);
};

export const NpsStateProvider = ({ children }) => {
  const [barScoreData, setBarScoreData] = useState(null);
  const [auditCycleData, setAuditCycleData] = useState(null);

  return (
    <NpsState.Provider value={{ barScoreData, setBarScoreData, auditCycleData, setAuditCycleData }}>
      {children}
    </NpsState.Provider>
  );
};

